var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
import { Form } from 'antd';
import { createVirtualBox, Layout, LayoutItem } from '@formily/react-schema-renderer';
import styled from 'styled-components';
import { useDeepFormItem } from '../../context';
import { normalizeCol, pickFormItemProps, pickNotFormItemProps } from '../../shared';
import { computeStyle } from './style';
var computeAttr = function (propAttr, layoutAttr, defaultValue) {
    if (typeof propAttr !== 'undefined')
        return propAttr;
    if (typeof layoutAttr !== 'undefined')
        return layoutAttr;
    return defaultValue;
};
var StyledLayoutItem = styled(function (props) {
    var _a, _b;
    var className = props.className, grid = props.grid, children = props.children, addonBefore = props.addonBefore, addonAfter = props.addonAfter, labelAlign = props.labelAlign, others = __rest(props, ["className", "grid", "children", "addonBefore", "addonAfter", "labelAlign"]);
    var formItemProps = pickFormItemProps(others);
    var cls = classnames((_a = {},
        _a[className] = true,
        _a['mega-layout-item'] = true,
        _a['mega-layout-item-col'] = grid,
        _a));
    var finalHelpInfo = null;
    if (props.inset && formItemProps.validateStatus) {
        finalHelpInfo = React.createElement("div", { className: "mega-layout-item-inset-help" }, formItemProps.help[0]);
    }
    var finalFormItem = function (cls) { return (React.createElement(Form.Item, __assign({ className: cls }, formItemProps),
        React.createElement("div", { className: "mega-layout-item-content" },
            addonBefore ? React.createElement("p", { className: "formily-mega-item-before" }, addonBefore) : null,
            children,
            addonAfter ? React.createElement("p", { className: "formily-mega-item-after" }, addonAfter) : null))); };
    if (grid) {
        return React.createElement("div", { className: classnames((_b = {},
                _b[cls] = true,
                _b['mega-layout-item-inset'] = props.inset,
                _b['mega-layout-item-inset-has-error'] = formItemProps.validateStatus === 'error',
                _b['mega-layout-item-inset-has-warning'] = formItemProps.validateStatus === 'warning',
                _b)) },
            finalFormItem(className),
            finalHelpInfo);
    }
    return finalFormItem(cls);
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["", ""], ["", ""])), function (props) { return computeStyle(props); });
var StyledLayoutWrapper = styled(function (props) {
    var formItemProps = pickFormItemProps(props);
    var labelAlign = formItemProps.labelAlign, addonAfter = formItemProps.addonAfter, addonBefore = formItemProps.addonBefore, others = __rest(formItemProps, ["labelAlign", "addonAfter", "addonBefore"]);
    others.children = props.children;
    others.className = props.className;
    return React.createElement(Form.Item, __assign({}, others));
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), function (props) { return computeStyle(props); });
var StyledLayoutNestWrapper = styled(function (props) {
    var children = props.children, style = props.style, className = props.className;
    return React.createElement("div", { style: style, className: classnames('mega-layout-nest-container', className) }, children);
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), function (props) { return computeStyle(props, true); });
var MegaLayout = function (props) {
    var children = props.children, addonBefore = props.addonBefore, addonAfter = props.addonAfter, description = props.description, megaLayoutClassName = props.className, others = __rest(props, ["children", "addonBefore", "addonAfter", "description", "className"]);
    var layoutProps = props.layoutProps || {};
    var size = useDeepFormItem().size;
    return React.createElement(Layout, __assign({ defaultSettings: {
            gutter: 20,
        } }, others, { size: size, children: function (layout) {
            var inline = layout.inline, required = layout.required, columns = layout.columns, label = layout.label, labelAlign = layout.labelAlign, grid = layout.grid, gutter = layout.gutter, autoRow = layout.autoRow, span = layout.span, contextColumns = layout.contextColumns, full = layout.full, context = layout.context, isRoot = layout.isRoot, responsive = layout.responsive, inset = layout.inset, hasBorder = layout.hasBorder, enableSafeWidth = layout.enableSafeWidth;
            var isSecondary = context.isRoot;
            var itemProps = {
                enableSafeWidth: enableSafeWidth,
                isSecondary: isSecondary,
                inline: inline,
                grid: grid,
                autoRow: autoRow,
                gutter: gutter,
                full: full,
                context: context,
                columns: columns,
                contextColumns: contextColumns,
                isRoot: isRoot,
                isLayout: true,
                responsive: responsive,
                size: size,
                inset: inset,
                hasBorder: hasBorder,
            };
            if (label) {
                var labelWidth = computeAttr(layoutProps.labelWidth, context.labelWidth, -1);
                var wrapperWidth = computeAttr(layoutProps.wrapperWidth, context.wrapperWidth, -1);
                var labelCol = computeAttr(layoutProps.labelCol, context.labelCol, -1);
                var wrapperCol = computeAttr(layoutProps.wrapperCol, context.wrapperCol, -1);
                var labelAlign_1 = computeAttr(layoutProps.labelAlign, context.labelAlign, -1);
                if (labelAlign_1)
                    itemProps.labelAlign = labelAlign_1;
                if (labelCol !== -1)
                    itemProps.labelCol = normalizeCol(labelCol);
                if (wrapperCol !== -1)
                    itemProps.wrapperCol = normalizeCol(wrapperCol);
                if (labelWidth !== -1)
                    itemProps.labelWidth = labelWidth;
                if (wrapperWidth !== -1)
                    itemProps.wrapperWidth = wrapperWidth;
            }
            var ele = React.createElement(StyledLayoutWrapper, __assign({ className: classnames("mega-layout-container", megaLayoutClassName || ''), label: label, required: required, help: description, labelAlign: label ? labelAlign : undefined }, itemProps),
                React.createElement("div", { className: "mega-layout-container-wrapper" },
                    addonBefore ? React.createElement("p", { className: "mega-layout-container-before" }, addonBefore) : null,
                    React.createElement("div", { className: classnames('mega-layout-container-content', { grid: grid }) }, children),
                    addonAfter ? React.createElement("p", { className: "mega-layout-container-after" }, addonAfter) : null));
            if (!props.grid && grid) {
                return React.createElement(StyledLayoutNestWrapper, __assign({ nested: true }, { span: span, columns: columns, contextColumns: contextColumns, gutter: gutter, isSecondary: isSecondary, context: context, responsive: responsive }), ele);
            }
            return ele;
        } }));
};
var MegaLayoutItem = function (props) {
    var children = props.children, schemaChildren = props.schemaChildren, itemProps = props.itemProps, others = __rest(props, ["children", "schemaChildren", "itemProps"]);
    var megaProps = (schemaChildren ? others['x-mega-props'] : others['mega-props']) || {};
    var isObjectField = others.type === 'object';
    return React.createElement(LayoutItem, megaProps, function (layoutProps) {
        var componentProps = pickNotFormItemProps(others);
        var schemaComponent = schemaChildren;
        if (layoutProps) {
            var addonBefore = megaProps.addonBefore, addonAfter = megaProps.addonAfter;
            var columns = layoutProps.columns, span = layoutProps.span, gutter = layoutProps.gutter, grid = layoutProps.grid, inline = layoutProps.inline, labelWidth = layoutProps.labelWidth, wrapperWidth = layoutProps.wrapperWidth, labelAlign = layoutProps.labelAlign, labelCol = layoutProps.labelCol, wrapperCol = layoutProps.wrapperCol, full = layoutProps.full, responsive = layoutProps.responsive, size = layoutProps.size, inset = layoutProps.inset, hasBorder = layoutProps.hasBorder, context = layoutProps.context, enableSafeWidth = layoutProps.enableSafeWidth;
            var isSecondary = context.isRoot;
            itemProps.isSecondary = isSecondary;
            itemProps.hasBorder = hasBorder;
            itemProps.inset = inset;
            itemProps.labelAlign = labelAlign;
            itemProps.inline = inline;
            itemProps.grid = grid;
            itemProps.gutter = gutter;
            itemProps.span = span;
            itemProps.columns = columns;
            itemProps.full = full;
            itemProps.enableSafeWidth = enableSafeWidth;
            itemProps.responsive = responsive;
            if (labelCol !== -1)
                itemProps.labelCol = normalizeCol(labelCol);
            if (wrapperCol !== -1)
                itemProps.wrapperCol = normalizeCol(wrapperCol);
            if (labelWidth !== -1)
                itemProps.labelWidth = labelWidth;
            if (wrapperWidth !== -1)
                itemProps.wrapperWidth = wrapperWidth;
            if (addonBefore)
                itemProps.addonBefore = addonBefore;
            if (addonAfter)
                itemProps.addonAfter = addonAfter;
            if (full) {
                componentProps.style = __assign(__assign({}, (componentProps.style || {})), { width: '100%', flex: 1 });
            }
            if (size) {
                componentProps.size = size;
            }
            if (isObjectField) {
                var objectFieldProps = __assign({}, megaProps);
                objectFieldProps.label = itemProps.label;
                return React.createElement(MegaLayout, objectFieldProps, (schemaChildren ? children(schemaComponent) : children(componentProps)));
            }
            return React.createElement(StyledLayoutItem, itemProps, (schemaChildren ? children(schemaComponent) : children(componentProps)));
        }
        return children();
    });
};
var FormMegaLayout = createVirtualBox('mega-layout', MegaLayout);
export { MegaLayout, MegaLayoutItem, FormMegaLayout, };
var templateObject_1, templateObject_2, templateObject_3;
